import { useQuery } from '@apollo/client/react';
import React, { useState } from 'react';
import './AddAssetLoadModal.scss';
import { Table } from 'react-bootstrap';
import { Loading } from '../../../_common';
import { DropdownOption } from '../../../_common/SearchableDropdown/SearchableDropdown';
import {
    AssetInfoType,
    GetAllEquipmentTypes,
    GetEquipmentsInfo_getEquipmentsInfo as EquipmentsInfo
} from '../../../../types/schemaTypes';
import { GET_ALL_EQUIPMENT_TYPES } from '../../../../graphql/client/queries';
import AddEquipmentsDetailsRow from './AddEquipmentsDetailsRow';
import { useAuthContext } from '../../../Auth/AuthProvider/AuthProvider';
import { PermissionEnum } from '../../../../types/PermissionEnum';

interface AssetInfoToSaveProps {
    index: number;
    assetTypeId: number | null;
    assetType: string | null;
    assetId: number | null;
    assetDescrip: string | null;
    quantity: number | null;
}

interface AddEquipmentsDetailsProps {
    assetInfo: AssetInfoType[];
    assetInfoToSave: AssetInfoToSaveProps[] | undefined;
    setAssetInfoToSave: React.Dispatch<React.SetStateAction<AssetInfoToSaveProps[] | undefined>>;
    equipmentsInfo: EquipmentsInfo | undefined;
    updatePaycode: () => void;
    infoLoading: boolean;
    disableEquipmentIdSelection?: boolean;
}

const AddEquipmentsDetails = ({
    assetInfo,
    assetInfoToSave,
    setAssetInfoToSave,
    equipmentsInfo,
    updatePaycode,
    infoLoading,
    disableEquipmentIdSelection = false,
}: AddEquipmentsDetailsProps): React.ReactElement => {
    const canEditAssets = useAuthContext().userHasPermission(PermissionEnum.EditAssets);

    const [rowCount, setRowCount] = useState(assetInfo?.length === 0 ? 1 : assetInfo.length);

    const asssetTypes: DropdownOption[] = [];
    const { data, loading } = useQuery<GetAllEquipmentTypes>(GET_ALL_EQUIPMENT_TYPES);
    if (data && data.getAllEquipmentTypes) {
        let isMatsSelected = false;
        let isForkliftRampsSelected = false;
        let isMiscellaneousSelected = false;
        assetInfoToSave?.map(assetInfo => {
            if (assetInfo.assetType === "Mats") isMatsSelected = true;
            if (assetInfo.assetType === "Forklift Ramp") isForkliftRampsSelected = true;
            if (assetInfo.assetType === "Miscellaneous") isMiscellaneousSelected = true;
        })
        data.getAllEquipmentTypes.map(item => {
            if (
                item && (
                    (!isMatsSelected || (isMatsSelected && item.name !== "Mats")) &&
                    (!isForkliftRampsSelected || (isForkliftRampsSelected && item.name !== "Forklift Ramp")) &&
                    (!isMiscellaneousSelected || (isMiscellaneousSelected && item.name !== "Miscellaneous"))
                )
            )
                asssetTypes.push(item)
        })
    }

    const handleOnClickAddEquipment = () => {
        setRowCount(rowCount + 1);
    };

    const renderEquipmentsDetailsRow = () => {
        const EquipmentsDetailsRows: React.ReactElement[] = assetInfo.map((info, index) => (
            <AddEquipmentsDetailsRow
                key={index}
                index={index}
                asset={info}
                asssetTypes={asssetTypes}
                assetInfoToSave={assetInfoToSave}
                setAssetInfoToSave={setAssetInfoToSave}
                equipmentsInfo={equipmentsInfo}
                updatePaycode={updatePaycode}
                loading={infoLoading}
                isEditable={canEditAssets}
                disableEquipmentIdSelection={disableEquipmentIdSelection}
            />
        ))

        for (let index = assetInfo.length; index < rowCount; index++) {
            EquipmentsDetailsRows.push(
                <AddEquipmentsDetailsRow
                    key={index}
                    index={index}
                    asset={undefined}
                    asssetTypes={asssetTypes}
                    assetInfoToSave={assetInfoToSave}
                    setAssetInfoToSave={setAssetInfoToSave}
                    equipmentsInfo={equipmentsInfo}
                    updatePaycode={updatePaycode}
                    loading={infoLoading}
                    isEditable={canEditAssets}
                    disableEquipmentIdSelection={disableEquipmentIdSelection}
                />
            )
        }
        return EquipmentsDetailsRows;
    }

    return (
        <div className='AddAssetDetails-Container'>
            <div className='AddAssetDetails-Header'>
                Equipment Details
            </div>

            <Table striped bordered className="AddAssetDetails-Edit-Grid">
                <thead>
                    <tr>
                        <th className='col-md-2'>Equipment Type</th>
                        <th className='col-md-1'>Quantity</th>
                        <th className='col-md-2'>ID</th>
                        <th className='col-md-1'>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <div className="AddAsset-SpinnerContainer">
                            <Loading />
                        </div>
                    ) : (
                        renderEquipmentsDetailsRow()
                    )}
                </tbody>
            </Table>

            {
                canEditAssets && (
                    <div className='AddAssetDetails-Buttons-Container' onClick={handleOnClickAddEquipment}>
                        <i className="material-icons AddAssetDetails-AddEquipment-Icon">add_circle</i>
                        <span className="AddAssetDetails-AddEquipment-Link">Add Equipment</span>
                    </div>
                )
            }
        </div>
    )
}

export default AddEquipmentsDetails;

